import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import "./assets/scss/App.scss";

import Widgets from "./Widgets";
import Deploy from "./Deploy";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/:widget">
          <Deploy type="widget">
            <Widgets />
          </Deploy>
        </Route>
      </Switch>
      <div id="modal"></div>
    </Router>
  );
}

export default App;
